import { ref } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import { ACTION } from '../components/UpdatePersonalGoalModal/consts';

const useUpdatePersonalGoalModal = () => {
  const isOpen = ref(false);
  const action = ref<ACTION>();

  const openUpdatePersonalGoalModal = (modalAction: ACTION) => {
    action.value = modalAction;
    isOpen.value = true;
  };

  return { openUpdatePersonalGoalModal, isOpen, action };
};
export default createSharedComposable(useUpdatePersonalGoalModal);
